import request from '@/utils/request'

let UserApi = {

  /*用户登录*/
  login(data, errorback) {
    return request._post('/shop/passport/login', data, errorback);
  },
  saasLogin(data, errorback) {
    return request._post('/shop/passport/saasLogin', data, errorback);
  },
  /*退出登录*/
  loginOut(data, errorback) {
    return request._post('/shop/passport/logout', data, errorback);
  },
  /*添加用户*/
  adduser(data, errorback) {
    return request._post('/shop/user/user/add', data, errorback);
  },

  /*修改用户*/
  edituser(data, errorback) {
    return request._post('/shop/user.user/edit', data, errorback);
  },
  /*充值*/
  userRecharge(data, errorback) {
    return request._post('/shop/user.user/recharge', data, errorback);
  },
  /*删除用户*/
  deleteuser(data, errorback) {
    return request._post('/shop/user.user/delete', data, errorback);
  },

  /*用户列表*/
  userlist(data, errorback) {
    return request._post('/shop/user.user/index', data, errorback);
  },
  /*等级列表*/
  gradelist(data, errorback) {
    return request._post('/shop/user.grade/index', data, errorback);
  },
  /*等级列表*/
  gradelog(data, errorback) {
    return request._post('/shop/user.grade/log', data, errorback);
  },
  /*添加等级*/
  addgrade(data, errorback) {
    return request._post('/shop/user.grade/add', data, errorback);
  },
  /*修改等级*/
  editGrade(data, errorback) {
    return request._post('/shop/user.grade/edit', data, errorback);
  },
  /*删除等级*/
  deletegrade(data, errorback) {
    return request._post('/shop/user.grade/delete', data, errorback);
  },
  /*用户余额*/
  BalanceLog(data, errorback) {
    return request._get('/shop/user.Balance/log', data, errorback);
  },
  /*充值记录*/
  RechargeOrder(data, errorback) {
    return request._post('/shop/user.Recharge/order', data, errorback);
  },
  /*修改密码*/
  EditPass(data, errorback) {
    return request._post('/shop/passport/editPass', data, errorback);
  },
  /*用户标签*/
  toEditTag(data, errorback) {
    return request._get('/shop/user.user/toEditTag', data, errorback);
  },
  /*用户标签*/
  editTag(data, errorback) {
    return request._post('/shop/user.user/editTag', data, errorback);
  },
  /*会员套餐列表*/
  getVip(data, errorback) {
    return request._post('/shop/user.Vip/list', data, errorback);
  },
  /*会员套餐详情*/
  DetailVip(data, errorback) {
    return request._get('/shop/user.Vip/edit', data, errorback);
  },
  /*会员套餐*/
  addVip(data, errorback) {
    return request._post('/shop/user.Vip/add', data, errorback);
  },
  /*会员套餐修改*/
  editVip(data, errorback) {
    return request._post('/shop/user.Vip/edit', data, errorback);
  },
  /*会员套餐删除*/
  delVip(data, errorback) {
    return request._post('/shop/user.Vip/del', data, errorback);
  },
  /*数据大屏*/
  webindex(data, errorback) {
    return request._post('/shop/index/web', data, errorback);
  },
  //设置用户黑名单
  setblack(data, errorback){
    return request._post('/shop/user.user/isBlack', data, errorback);
  },
  
  //设置用户来源
  userLog(data, errorback){
    return request._get('/shop/user.user/userLog', data, errorback);
  },
  

  

}

export default UserApi;



// WEBPACK FOOTER //
// ./src/api/user.js